import { AppointmentStartingPoints } from "@libs/analytics/app-insights/app-insights.enums.ts";
import { CalendarEventType } from "@libs/gateways/booking/BookingGateway.dtos.ts";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

export const useAppointmentLink = (): NavLink => {
  const { booking } = useStores();
  return {
    name: "New appointment",
    key: "newAppointment",
    permissions: [
      Permission.AppointmentTypeRead,
      Permission.BookingScheduleRead,
      Permission.CalendarEventRead,
      Permission.CalendarEventWrite
    ],
    onClick: () => {
      booking.ui.showCalendarEventDialog(
        {
          type: CalendarEventType.Appointment
        },
        AppointmentStartingPoints.NavBarAddAppointmentButton
      );
    },
    showBorder: true
  };
};
